import { useTheme } from '@mui/material';
import LayoutStatusPage from '../../components/LayoutStatusPage';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const Updating = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <LayoutStatusPage
        imgUrl={
          theme.palette.mode === 'dark' ? 'coffee-dark.svg' : 'coffee.svg'
        }
        title={t('updating.title')}
        text={t('updating.first_text')}
        secondText={t('updating.second_text')}
        routerBack=""
      />
    </>
  );
};
export default Updating;
